import React from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const TeamUniquePage = () => {
  const { teamListApi } = apiPath;
  const member = useParams();

  const [teamMember, teamMemberLoading] = useFetch(
    teamListApi,
    false,
    member.id
  );
  if (teamMemberLoading) {
    return <Loading />;
  }
  const { name, image, designation, description, social } = teamMember;
  const socialData = [];
  social.map((item, index) => {
    socialData.push({
      label: `Social Link ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
    });
  });
  const data = [
    {
      elementType: "file",
      label: "Member Photo",
      type: "file",
      name: "image",
      defaultValue: image,
      required: false,
    },
    {
      elementType: "input",
      label: "Member Name",
      type: "Text",
      name: "name",
      defaultValue: name,
      required: true,
    },
    {
      elementType: "input",
      label: "Member Designation",
      type: "Text",
      name: "designation",
      defaultValue: designation,
      required: true,
    },
    {
      elementType: "textField",
      label: "Member Description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
  ];
  const multiDimensionalData = [
    {
      elementType: "nested",
      label: "Social Links",
      name: "social",
      multipleData: socialData,
      multiple: true,
      required: false,
    },
  ];

  const useData = data.concat(multiDimensionalData);
  const update = (data) => {
    updateData(`${teamListApi}/${member.id}`, data);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        multiDimensionalData={multiDimensionalData}
        update={update}
      />
    </div>
  );
};

export default TeamUniquePage;
